import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { ScrollToHOC } from 'react-scroll-to';

import { ExperienceHome } from './experienceHome.component';
import {
  selectCurrentExperience,
  selectSimilarExperiences,
  selectSameContextExperiencesCount,
  selectExperienceContextHomeName,
  selectExperienceContextHomeRoute,
} from '../../../modules/experience';
import { OverlayActions } from '../../../modules/overlay';
import { AnalyticsActions } from '../../../modules/analytics';

const mapStateToProps = createStructuredSelector({
  experience: selectCurrentExperience,
  contextName: selectExperienceContextHomeName,
  sameMarketExperiencesLength: selectSameContextExperiencesCount,
  similarExperiences: selectSimilarExperiences,
  currentExperienceParentRoute: selectExperienceContextHomeRoute,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showPolicy: OverlayActions.showPolicy,
      logGTMEvent: AnalyticsActions.logGTMEvent,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  ScrollToHOC
)(ExperienceHome);
